export default __webpack_public_path__ + "images/adb2ce79e35963480e2b82a5214f225a-comics.webp";